module.exports = __webpack_public_path__ + "img/tg.86611871.svg";